class News {
    namespace: HTMLElement | null;
    loadingContainer: HTMLElement | null | undefined;

    constructor() {
        this.namespace = document.getElementById('page-news'); 
        this.loadingContainer = this.namespace?.querySelector('.loading-container');
        this.initPage();
    }

    initPage() {
        if (!this.namespace) return;
        
        this.getTweets();
    } 

    getTweets() {
        fetch('/.netlify/functions/tweets-fetch')
            .then(response => response.json())
            .then(data => {
                this.renderTweets(data);
                this.loadingContainer?.remove();
            })
            .catch(error => {
                console.error('Error fetching tweets:', error);
            });
    }

    private parseTweetText(text: string): string {
        // Parse URLs
        const urlRegex = /(https?:\/\/[^\s]+)/g;
        text = text.replace(urlRegex, (url) => {
            return `<a href="${url}" target="_blank" rel="noopener noreferrer" class="text-blue-500 hover:text-blue-700">${url}</a>`;
        });

        // Parse Twitter usernames
        const usernameRegex = /@(\w+)/g;
        text = text.replace(usernameRegex, (match, username) => {
            return `<a href="https://twitter.com/${username}" target="_blank" rel="noopener noreferrer" class="text-blue-500 hover:text-blue-700">${match}</a>`;
        });

        // Parse hashtags
        const hashtagRegex = /#(\w+)/g;
        text = text.replace(hashtagRegex, (match, hashtag) => {
            return `<a href="https://twitter.com/hashtag/${hashtag}" target="_blank" rel="noopener noreferrer" class="text-blue-500 hover:text-blue-700">${match}</a>`;
        });

        return text;
    }

    private formatTweetDate(dateString: string): string {
        const date = new Date(dateString);
        return new Intl.DateTimeFormat('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        }).format(date);
    }

    private renderMedia(media: any[], username: string): string {
        if (!media || media.length === 0) return `
            <div class="tweet-media mt-2">
                <a href="https://x.com/${username}" target="_blank" rel="noopener noreferrer">
                    <img 
                        src="/static/images/placeholder.jpg" 
                        alt="Tweet media" 
                        class="rounded-lg max-w-full h-auto"
                        loading="lazy"
                    />
                </a>
            </div>
        `;
        
        // Get the first photo from the media array
        const firstPhoto = media.find(item => item.type === 'photo' || item.type === 'video');
        if (!firstPhoto) return '';
        
        return `
            <div class="tweet-media mt-2">
                <a href="${firstPhoto.url}" target="_blank" rel="noopener noreferrer">
                    <img 
                        src="${firstPhoto.media_url_https}:medium" 
                        alt="Tweet media" 
                        class="rounded-lg max-w-full h-auto"
                        loading="lazy"
                    />
                </a>
            </div>
        `;
    }

    renderTweets(data: any) {
        const tweets = data.tweets;
        const tweetsContainer = this.namespace?.querySelector('.tweets-container');
        if (!tweetsContainer) return;
        tweetsContainer.innerHTML = '';
        tweets.forEach((tweet: any) => {
            const tweetElement = document.createElement('div');
            tweetElement.classList.add('tweet', 'p-4', 'mb-4', 'bg-white', 'rounded-lg', 'shadow');
            const parsedText = this.parseTweetText(tweet.text);
            const formattedDate = this.formatTweetDate(tweet.created_at);
            const mediaHtml = this.renderMedia(tweet.media, data.user.username);
            
            tweetElement.innerHTML = `
                <div class="tweet-content">
                    ${mediaHtml}
                    <p class="date text-sm text-gray-500">${formattedDate}</p>
                    <p class="text-gray-800">${parsedText}</p>
                </div>
            `;
            tweetsContainer.appendChild(tweetElement);
        });
    }
}
export default News;